export const carouselTracks = document.querySelectorAll('.carousel-track') as NodeListOf<HTMLElement>;

// Clone items to create an infinite loop effect
carouselTracks.forEach((carouselTrack: HTMLElement) => {
    const trackItems = Array.from(carouselTrack.children) as HTMLElement[];

    trackItems.forEach(item => {
        const clone = item.cloneNode(true) as HTMLElement;
        carouselTrack.appendChild(clone);
    });
});
